export const SIZES = ["PP", "P", "M", "G", "GG", "XGG"];

export const safeArray = (v) => (Array.isArray(v) ? v : []);

export const buildBaseProductFromBarcode = (barcodePayload, productsFiltered, getColorsProduct) => {
    const { product, stock, variant } = barcodePayload;
    const colors = getColorsProduct(productsFiltered);

    return {
        ProductID: product.id,
        ProductName: product.name,
        ProductImage: "",
        ProductQuantity: 1,
        ProductColor: {},
        stockID: stock._id,
        variantID: variant._id,
        ProductPrice: product.price,
        ProductSize: stock.size,
        ProductNew: product.new,
        ProductSale: product.sale,
        ProductSalePrice: product.salePrice,
        colors,
        variants: productsFiltered?.variants,
        variant,
        stockQuantity: stock.quantity, // estoque disponível
        sizes: SIZES,
    };
};

export const normalizeOrderProduct = (p) => ({
    ...p,
    variant: p?.variant,
    variantID: p?.variant?._id ?? p?.variantID,
    ProductColor: {
        color: p?.variant?.color?.hex,
        colorName: p?.variant?.colorName,
        idVariant: p?.variant?._id,
    },
    ProductImage: p?.variant?.pictures?.[0]?.url || "",
});

export const getOrderProductKey = (p) => ({
    id: p?.ProductID ?? p?._id ?? p?.productId,
    variantId: p?.variantID ?? p?.variant?._id,
    colorHex: p?.ProductColor?.color ?? p?.variant?.color?.hex,
    size: p?.ProductSize,
});

export const isSameOrderProduct = (a, b) => {
    const ka = getOrderProductKey(a);
    const kb = getOrderProductKey(b);

    return (
        ka.id === kb.id &&
        ka.variantId === kb.variantId &&
        ka.colorHex === kb.colorHex &&
        ka.size === kb.size
    );
};

export const upsertOrderProduct = (products, newItem) => {
    const list = safeArray(products);
    const idx = list.findIndex((p) => isSameOrderProduct(p, newItem));

    if (idx >= 0) {
        return list.map((p, i) =>
            i === idx ? { ...p, ProductQuantity: (p.ProductQuantity ?? 1) + 1 } : p
        );
    }

    return [...list, newItem];
};
